<template>
	<v-list-item>
		<v-list-item-content>
			<v-list-item-title>{{item.title}}</v-list-item-title>
			<v-list-item-subtitle>
				<DateNote :date="item.updated.toDate()" name="Last updated: "></DateNote>		
			</v-list-item-subtitle>
		</v-list-item-content>
		<v-list-item-icon>
			<v-btn icon color="primary" link :to="`surveys/${item.id}`"><v-icon>mdi-arrow-right-bold</v-icon></v-btn>
		</v-list-item-icon>
	</v-list-item>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DateNote from "@/components/elements/DateNote"
	export default {
		name: "ListSurveys", 
		props: {
			item: {type: Object }
		},
		data: () => {
			return {
			}
		},
		components: {
			DateNote
		},
		computed: {
			...Vuex.mapState({
				surveys: state => state.surveys
			})
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>